import { render } from "./templates/toggle-switch.html?vue&type=template&id=6b9d7fd7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./styles/toggle-switch.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__